import { MobXProviderContext } from 'mobx-react';

import createContextHelpers from 'utils/create-context-helpers';

const StoresContext = MobXProviderContext;
export const { StoresProvider, useStores, withStores } = createContextHelpers(StoresContext, 'Stores');
